import user from "/user.svg?url";
import podium from "/podium.svg?url";
// @ts-ignore
import time from "/time-clock.svg?url";
import tournaments from "/tournaments.svg?url";
import avatar from "/user-avatar.svg?url";
import { ScrollBar } from "/utils/ScrollBarFactory";
import { useEffect, useRef, useState } from "react";
import Timer from "/components/core/DateTimer";
import SwiperCore from "swiper";

import { Swiper } from "swiper/react";
import { SwiperSlide } from "swiper/react";
import { FreeMode, Scrollbar } from "swiper/modules";
import { useAnimation } from "/context/AnimationProvider";

SwiperCore.use([FreeMode, Scrollbar]);

const Player = ({ player }) => {
  const userAvatar = player.user?.avatar.url;
  const places = ["first", "second", "third"];

  const placeItem = places[player.place - 1] || null;
  return (
    <>
      <div className={`user top`}>
        <div className="user-nav table-first">
          {placeItem ? (
            <img className="place-icon" src={`${placeItem}.svg`} alt="" />
          ) : (
            <p>#{player.place}</p>
          )}
        </div>
        <div className="user-nav table-second">
          <div className="avatar">
            <div className="icon">
              <img src={userAvatar ?? avatar} alt="" />
            </div>
            <p>{player.user.username} </p>
          </div>
        </div>
        <div className="user-nav table-third">
          <p>{player.score}</p>
        </div>
        <div className="user-nav table-max table-last">
          {player.prizes?.map((prize, index) => {
            return (
              <div className="prize" key={index}>
                <div className="top">
                  {prize.amount > 1 ? <p>{prize.amount}x</p> : null}
                  <div className="icon">
                    {prize.image ? (
                      <img src={prize.image} alt="" />
                    ) : (
                      <div className="ico"></div>
                    )}
                  </div>
                </div>
                <div className="bottom">
                  <p>{prize.name}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

const About = ({ activeTab }) => {
  return (
    <>
      <div
        className={`wrapper-info block df fd-c ai-c ${activeTab === "about" ? "active" : ""}`}
      >
        <div className="icon df w-full">
          <img src="/rewards/uniswap-cup.png" alt="" />
        </div>

        <div className="text-shadow text">
          <br />
          <br />
          <p>
            Participate in the Uniswap Cup Tournament and let your skills drive
            you towards securing <br />
            <span className="gradient">tokenized Diamonds & Silver</span>,
            together with some $TICO Tokens!
          </p>
        </div>

        {/* {!isEnded && <Timer />} */}
      </div>
    </>
  );
};

const Board = ({
  leaderboard,
  isMobile,
  getLeaders,
  activePage,
  activeTab,
  isLoading,
}) => {
  const scrollerRef = useRef(null);
  const scrollbarRef = useRef(null);
  const currentpage = leaderboard[activePage];
  const initedBoard = isMobile
    ? currentpage?.data
    : Object.values(leaderboard)
        .map((item) => item.data)
        .flat();

  const pagination = isMobile ? currentpage?.links : null;
  const meta = isMobile ? currentpage?.meta : null;
  useEffect(() => {
    !isMobile && scrollbarRef.current && scrollbarRef.current._init();
    return () => {};
  }, [leaderboard]);

  useEffect(() => {
    const block = scrollerRef.current;
    if (isMobile || !block) return;
    let scroll = null;
    setTimeout(() => {
      scroll = ScrollBar.create({ scroller: block });
      scrollbarRef.current = scroll;
    }, 1000);

    const handleScroll = () => {
      if (block.scrollTop + block.clientHeight >= block.scrollHeight * 0.9) {
        // @ts-ignore
        if (window.active_page >= window.last_load_page) {
          return;
        }
        getLeaders();
      }
    };

    block.addEventListener("scroll", handleScroll);
    return () => {
      scroll?.kill();
      scrollbarRef.current = null;
      block.removeEventListener("scroll", handleScroll);
    };
  }, [isMobile]);

  return (
    <div
      className={`wrapper-board block df fd-c w-full ${activeTab === "leaderboard" ? "active" : ""}`}
    >
      <Swiper slidesPerView={"auto"} scrollbar={true} freeMode={true}>
        <SwiperSlide className="slide df fit-cover">
          <div className="wrapper-table">
            <div className="table font-16-semi">
              <div className="table-top">
                <div className="table-top-nav table-first">
                  <div className="nav">
                    <div className="icon">
                      <img src={podium} alt="" />
                    </div>
                  </div>
                </div>
                <div className="table-top-nav table-second">
                  <div className="nav">
                    <div className="icon">
                      <img src={user} alt="" />
                    </div>
                  </div>
                </div>
                <div className="table-top-nav table-third">
                  <div className="nav">
                    <div className="icon icon_points">
                      {/* <img src={time} alt="" /> */}
                    </div>
                  </div>
                </div>
                <div className="table-top-nav table-max table-last">
                  <div className="nav">
                    <div className="icon">
                      <img src={tournaments} alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-list">
                <p className="table-list-title font-16-semi">
                  REWARDED PLACES: TOP 500
                </p>
                <div className="scroler-wrapper">
                  <div
                    className="scroler df fd-c"
                    ref={scrollerRef}
                    data-prevent-observer
                  >
                    {initedBoard &&
                      initedBoard.map((player, index) => {
                        return <Player player={player} key={index} />;
                      })}
                    {isLoading && !isMobile && (
                      <div
                        className="loading df w-full jc-c ai-c"
                        style={{ height: "120px", flex: "none" }}
                      >
                        <div className="mask_loader"></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
      {pagination && (
        <>
          <div className="navigation df w-full ai-c">
            <button
              className="nav prev icon_arrow"
              onClick={() => getLeaders(activePage - 1)}
              disabled={!pagination?.prev}
            ></button>

            <div className="navs df ai-c fixel_16_sbl">
              {activePage !== 1 && (
                <>
                  <button
                    className="nav"
                    disabled={activePage == 1}
                    onClick={() => getLeaders(1)}
                  >
                    {1}
                  </button>
                  <div className="nav">...</div>
                </>
              )}

              <div className="nav active">{activePage}</div>
              {activePage !== meta?.last_page && (
                <>
                  <div className="nav">...</div>
                  <button
                    className="nav"
                    disabled={activePage == meta?.last_page}
                    onClick={() => getLeaders(meta?.last_page)}
                  >
                    {meta?.last_page}
                  </button>
                </>
              )}
            </div>
            <button
              className="nav next icon_arrow"
              onClick={() => getLeaders(activePage + 1)}
              disabled={!pagination?.next}
            ></button>
          </div>
        </>
      )}
    </div>
  );
};

const tabs = [
  { label: "About", key: "about", component: About },
  { label: "Leaderboard & Prizes", key: "leaderboard", component: Board },
];
export default function Leaderboard({
  leaderboard,
  getLeaders,
  activePage,
  isLoading,
  isEnded,
}) {
  const [activeTab, setActiveTab] = useState(tabs[1].key);
  const { isMobile } = useAnimation();

  // @ts-ignore
  const Component = tabs.find((tab) => tab.key === activeTab)?.component;

  return (
    <>
      <section className="leaderboard">
        <div
          className={`wrapper w-full pd-lr-md df ai-c ${leaderboard ? "" : "jc-c"}`}
          data-pin-end
        >
          {isMobile && leaderboard && (
            <div className="mobile-tabs w-full df fixel_16_sbl">
              {tabs.map((tab) => (
                <button
                  className={`tab ${activeTab === tab.key ? "active" : ""}`}
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          )}
          <div className="wrapper-sections df fd-c w-full">
            {leaderboard && (
              <Board
                {...{
                  leaderboard,
                  isMobile,
                  getLeaders,
                  activePage,
                  activeTab,
                  isLoading,
                }}
              />
            )}
            <About activeTab={activeTab} />
          </div>
        </div>
      </section>
    </>
  );
}
